import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import { CoachSettingsController } from './coach-settings.controller';
import { CoachSettingsStore } from './coach-settings.store';

@Component({
	selector: 'spr-coach-settings',
	templateUrl: './coach-settings.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachSettingsStore, CoachSettingsController],
	host: {
		class: 'h-full flex flex-col items-stretch',
	},
})
export class CoachSettingsComponent {
	public activeTabIndex$: Observable<number>;

	constructor(private _controller: CoachSettingsController) {
		this.activeTabIndex$ = _controller.activeTabIndex$;
	}

	public onActiveIndexChange(index: number) {
		this._controller.updateActiveTabIndex(index);
	}
}
